module.exports = __webpack_public_path__ + "img/founder_new12.8f6ee183.png";